import React from 'react';
import swal from 'sweetalert';
import { GridCell } from '@progress/kendo-react-grid';

export default function CellWithEditing(edit, editBatch, deleteTransaction) {
  return class extends GridCell {
    constructor(props) {
      super(props);
      // console.log(this.props.dataItem);
    }

    render() {
      return (
        <td>
          <button
            className="admin-k-button"
            onClick={() => {
              editBatch(this.props.dataItem);
            }}
            disabled={!(this.props.dataItem.IsBatchOpen && (this.props.dataItem.Description == "Cash" || this.props.dataItem.Description == "Check"))} 
          >
            <i className="fas fa-pen"></i>
          </button>
          <button
            className="admin-k-button "
            onClick={() => {
              edit(this.props.dataItem);
            }}
          >
            <i className="fas fa-file-pdf"></i>
          </button>
          <button
            className="admin-k-button "
            onClick={() => {
              swal({
                title: 'Are you sure?',
                text: `Delete transaction id: ${this.props.dataItem.TransactionId}`,
                icon: 'warning',
                buttons: {
                  cancel: 'CANCEL',
                  confirm: 'OK'
                },
                dangerMode: true
              }).then((value) => (value ? deleteTransaction(this.props.dataItem) : null));
            }}
            disabled={!(this.props.dataItem.IsBatchOpen && (this.props.dataItem.Description == "Cash" || this.props.dataItem.Description == "Check"))} 
          >
            <i className="fas fa-trash"></i>
          </button>
          {/* &nbsp;
          {this.props.dataItem.isActive ? (
            <button
              className="admin-k-button "
              onClick={() => {
                swal({
                  title: 'Are you sure?',
                  text: `Deleting, ${this.props.dataItem.name} Size will result in in-correct product `,
                  icon: 'warning',
                  buttons: {
                    cancel: 'CANCEL',
                    confirm: 'OK'
                  },
                  dangerMode: true
                }).then((value) => (value ? toggleActive(this.props.dataItem) : null));
              }}
            >
              <i className="fas fa-times-circle"></i>
              DEACTIVATE
            </button>
          ) : (
            <button
              className="admin-k-button "
              onClick={() => {
                swal(
                  `Are you sure you want to re-activate ${this.props.dataItem.name} ?`
                ).then((value) => (value ? toggleActive(this.props.dataItem) : null));
              }}
            >
              <i className="fas fa-check-circle"></i>
              ACTIVATE
            </button>
          )} */}
        </td>
      );
    }
  };
}
